import saleImg from '@/assets/staff_sale.svg'
import seatImg from '@/assets/staff_seat.svg'
import channelImg from '@/assets/staff_channel.svg'

export const  staffTypeMap  = {
  SALES_TEMPLATE: {
    title: "营销员/设计师/交付人员/职能员工",
    key: 'SALES_TEMPLATE',
    img: saleImg,
    bgColor: '#D9F8FF',
  },
  CALL_PAGE: {
    title: "云客服",
    key: 'CALL_PAGE',
    img: seatImg,
    bgColor: '#FFE5DE',
  },
  CHANNEL_CLUE_ADD: {
    title: "渠道人员",
    key: 'CHANNEL_CLUE_ADD',
    img: channelImg,
    bgColor: '#DFE3FF',
  },
}